import { formatCurrency } from '../../Utilities/Utilities';
import styles from './product-card.module.scss';

const ProductCard = ({ name, price, photos, onClick }) => {
    return (
        <div className={styles.container} onClick={onClick}>
            <img src={photos[0]} alt='display' />
            <div className={styles.priceBox}>
                <p>
                    <b>{name}</b>
                </p>
                <p>{formatCurrency(price)}</p>
            </div>
        </div>
    );
};

export default ProductCard;
